<div class="wrapSelectDate" [style]="{ w: w } | getStyles">

  <mat-form-field floatLabel="auto" class="o-matForm" [ngClass]="'o-matForm--' + bcg" [class]="'o-matForm--' + ({
                    value: manualDateInput,
                    active: datePicker.opened,
                    disabled: disabled,
                    error: invalidManualDate || isUnderage
                  } | getStateInput)">
    <input matInput [(ngModel)]="manualDateInput" (ngModelChange)="manualDateInputChanged($event)"
      (blur)="onManualDateBlur()" [placeholder]="placeholder" [disabled]="disabled" class="manual-date-input">



    <mat-datepicker-toggle matPrefix [for]="datePicker">
      <mat-icon matDatepickerToggleIcon (click)="datePicker.open()">
        <meSvg svgName="calendar_grey1&20" [stateInput]="{
                 value: manualDateInput,
                 active: datePicker.opened,
                 disabled: false,
                 error: required && !!(dateTouched$ | async) && !(date$ | async)
               } | getStateInput">
        </meSvg>
      </mat-icon>
    </mat-datepicker-toggle>

    <!-- <input matInput [matDatepicker]="datePicker" (dateChange)="onCalendarDateChange($event)" hidden /> -->
     <input matInput [matDatepicker]="datePicker" [(ngModel)]="calendarDate" (dateChange)="onCalendarDateChange($event)" hidden />


    <mat-datepicker #datePicker (closed)="onCalendarClosed()"></mat-datepicker>
  </mat-form-field>

  <error *ngIf="required && !!(dateTouched$ | async) && !(date$ | async)" text="Choose a date"></error>
  <error *ngIf="invalidManualDate" text="Enter a valid date in MM/DD/YYYY format"></error>
  <!-- <error *ngIf="!invalidManualDate && isUnderage" text="You must be at least 11 years old to create an account"></error> -->
   <error *ngIf="!invalidManualDate && isUnderage"
       [text]="showFullUnderageMessage ? 'You must be at least 11 years old to create an account' : 'You must be at least 11 years old'">
    </error>
</div>